import { IOfferListModalLang } from '../../../types/lang'

export const offerListModalLang: IOfferListModalLang = {
	offer_list_modal: {
		title_bind: 'Binding offers to scope_ru',
		title_unbind: 'Unbinding offers from scope_ru',
		title_unscoped: 'Unscoped offers_ru',
		title_unscoped_in_group: 'Unscoped offers in group_ru',
		title_view: 'View offers in scope_ru',
		btn_close: 'Close_ru'
	}
}